module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content setting"
  }, [_c('h2', [_vm._v("公司信息")]), _vm._v(" "), _c('div', {
    staticClass: "b-b m-b-md"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('form', [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("公司名称：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.companyInfo.name),
      expression: "companyInfo.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "公司名称：北京华宇互联科技有限公司",
      "required": "required",
      "autocomplete": "off",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.companyInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyInfo.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("公司简称：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.companyInfo.short_name),
      expression: "companyInfo.short_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "公司简称：华宇互联",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.companyInfo.short_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyInfo.short_name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.short_name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("统一社会信用代码：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.companyInfo.credit_code),
      expression: "companyInfo.credit_code",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "统一社会信用代码：9188888888888888888N",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.companyInfo.credit_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyInfo.credit_code = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("注册邮箱：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.companyInfo.email),
      expression: "companyInfo.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "注册邮箱：test@test.com",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.companyInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyInfo.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.email))]), _vm._v(" "), _c('verify-code', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.companyInfo.email != _vm.user.email && _vm.verify.email),
      expression: "companyInfo.email != user.email && verify.email"
    }],
    attrs: {
      "val": _vm.companyInfo.email,
      "msg": _vm.error.email,
      "type": 2
    },
    on: {
      "success": _vm.verifySuccess
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("绑定手机：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.companyInfo.phone),
      expression: "companyInfo.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "绑定手机：18888888888",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.companyInfo.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyInfo.phone = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.phone))]), _vm._v(" "), _c('verify-code', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.companyInfo.phone != _vm.company.phone && _vm.verify.phone) || _vm.user.phone_is_verify === -1),
      expression: "(companyInfo.phone != company.phone && verify.phone)||user.phone_is_verify === -1"
    }],
    attrs: {
      "val": _vm.companyInfo.phone,
      "msg": _vm.error.phone,
      "type": 1
    },
    on: {
      "success": _vm.verifySuccess
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("联系人姓名：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.companyInfo.principal.name),
      expression: "companyInfo.principal.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "联系人姓名：小明",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.companyInfo.principal.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyInfo.principal.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('label', {
    staticClass: "col-sm-4 n-p-r text-right"
  }, [_vm._v("联系人电话：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.companyInfo.principal.phone),
      expression: "companyInfo.principal.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "联系人电话：18888888888",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.companyInfo.principal.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyInfo.principal.phone = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 "
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.companyInfo.logo,
      "alt": _vm.companyInfo.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-t-sm text-center"
  }, [_vm._v("\n                        (推荐尺寸:200 x 200,3M以内)\n                    ")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "p-t-b-md text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.completeInfo()
      }
    }
  }, [_vm._v("保存企业信息")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-sm text-center"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary upload-btn",
    attrs: {
      "type": "button",
      "id": "upload-logo-btn"
    }
  }, [_vm._v("选择Logo")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ab6d68c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/setting.vue
// module id = 476
// module chunks = 1